import React from 'react';
import { setDialog } from '../reducers/dialogReducer';
import { useAppDispatch } from './useAppDispatch';
import MultiBookingActionScreen from '../components/MultiBookingActionScreen';
import { MultiBookingActionType } from './MultiBookingActionScreen/useMultiBookingActions';

const useCancelMultipleBooking = () => {
  const dispatch = useAppDispatch();
  const showCancellationDialog = ({
    longTermShiftContractId,
    professionalId,
  }: {
    longTermShiftContractId: string;
    professionalId?: string;
  }) => {
    dispatch(
      setDialog({
        Component: (
          <MultiBookingActionScreen
            type={MultiBookingActionType.CancelBooking}
            longTermContractId={longTermShiftContractId}
            professionalId={professionalId}
          />
        ),
        heading: {
          title: '',
        },
        maxWidth: 'lg',
        showCloseButton: true,
      }),
    );
  };

  return { showCancellationDialog };
};

export default useCancelMultipleBooking;
